import React from 'react';
import { Divider } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { InputFromUser } from '../Input/input';
import { Options } from '../../utils/Data';

/**
 * DiagnosisSection Component
 * Displays root cause and diagnosis fields in a clean, mobile-friendly layout
 */
const DiagnosisSection = ({
    values,
    errors,
    touched,
    handleChange,
    IsFilledForm,
}) => {
    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        {/* Section Header */}
                        <h4
                            style={{
                                color: '#111827',
                                fontWeight: '700',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px'
                            }}
                        >
                            <FeatherIcon icon="clipboard" size="20" style={{ color: '#4f46e5' }} />
                            Root Cause & Diagnosis
                        </h4>

                        <div className="row">
                            {/* Root Cause */}
                            <InputFromUser
                                disabled={IsFilledForm}
                                placeholder="Enter Your Root Cause"
                                type="multiple"
                                options={Options.Hetu}
                                name="rootCause"
                                onChange={v => {
                                    handleChange({
                                        target: {
                                            name: 'rootCause',
                                            value: v,
                                        },
                                    });
                                }}
                                value={values.rootCause}
                                FormGroupClassName="col-xl-4 col-md-12"
                                LabelClassName="col-form-label"
                                onBlur={undefined}
                                label="Root Cause"
                                touched={true}
                            />

                            {/* Diagnosis Fields */}
                            {values?.diagnosis?.map((item, i) => (
                                <React.Fragment key={i}>
                                    <InputFromUser
                                        touched={true}
                                        placeholder="Enter Your Diagnosis"
                                        type="text"
                                        name="diagnosis"
                                        onChange={v => {
                                            const newValue = [...values.diagnosis];
                                            newValue[i].diagnosis = v.target.value;
                                            handleChange({
                                                target: {
                                                    name: 'diagnosis',
                                                    value: newValue,
                                                },
                                            });
                                        }}
                                        value={values.diagnosis?.[i].diagnosis}
                                        FormGroupClassName="col-xl-4 col-md-12"
                                        LabelClassName="col-form-label"
                                        onBlur={undefined}
                                        label="Diagnosis"
                                    />

                                    <InputFromUser
                                        touched={true}
                                        placeholder="Enter others"
                                        type="text"
                                        name="diagnosis-other"
                                        onChange={v => {
                                            const newValue = [...values.diagnosis];
                                            newValue[i].other = v.target.value;
                                            handleChange({
                                                target: {
                                                    name: 'diagnosis',
                                                    value: newValue,
                                                },
                                            });
                                        }}
                                        value={values.diagnosis?.[i].other}
                                        FormGroupClassName="col-xl-4 col-md-12"
                                        LabelClassName="col-form-label"
                                        onBlur={undefined}
                                        label="Others"
                                    />

                                    {i < values.diagnosis.length - 1 && <Divider dashed />}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiagnosisSection;
